import React, { Component } from "react";
import Draggable from "react-draggable";
import { connect } from "react-redux";
//import {} from "../../actions/debuging-tool-actions";
import "./index.css";

class DebugingTool extends Component {
  componentDidUpdate(prevProps) {
    /* the properties to be checked */
    let names = [
      /* external components properties */
    ];

    /* if any of the 'names' fields have changed, recompute calculations */
    if (this.anyPropHasChanged(prevProps, names)) {
    }
  }
  /**
   * This method receives the previous properties object and an Array of
   * the properties to be determined if have changed and returns true if any
   * have changed, or false if all are the same.
   *
   * @param {Object} prevProps The previous properties of the component.
   * @param {Array<string>} propNames The Properties names array.
   */
  anyPropHasChanged(prevProps, propNames) {
    let changed = false;
    for (let name of propNames) {
      changed = this.props[name] !== prevProps[name] || changed;
    }
    return changed;
  }
  handleDragStop(event, node) {
    if (this.props.x !== node.x || this.props.y !== node.y) {
      this.props.debugingToolMoved(node.x, node.y);
    }
  }
  getScaledValue(value) {
    return this.props.scaleValue * (value / this.props.scalePixels);
  }
  renderDebugingTools() {
    /* render floating window */
    return (
      <div className="measureToolInfo">
        <h5>DEBUGING TOOL</h5>
        <hr />
        <form>
          <fieldset>
            <legend>{this.props.content[this.props.lang].measureTool}:</legend>
            {this.props.content[this.props.lang].feets}:{" "}
            {`${this.getScaledValue(this.props.measureToolPixels).toFixed(2)}`}
            <br />
            {this.props.content[this.props.lang].inches}:{" "}
            {`${(
              this.getScaledValue(this.props.measureToolPixels) * 12
            ).toFixed(2)}`}
          </fieldset>
        </form>
      </div>
    );
  }
  renderToolContent() {
    /* render the floating tools */
    return (
      <div className="DebugingTool">
        <div className="handle" />
        {this.renderDebugingTools()}
      </div>
    );
  }
  render() {
    if (this.props.enableDebuging) {
      return <Draggable handle=".handle">{this.renderToolContent()}</Draggable>;
    } else {
      return <span style={{ display: "none" }} />;
    }
  }
}

/* the container to component mapping */
const mapStateToProps = state => {
  return {
    x: state.debugingtool.x,
    y: state.debugingtool.y,
    /* measure tool properties */
    measureToolPixels: state.debugingtool.measureToolPixels,
    /* the global properties */
    lang: state.localization.lang,
    content: state.localization.content,
    scaleValue: state.globals.scaleValue,
    scalePixels: state.globals.scalePixels,
    enableDebuging: state.globals.enableDebuging,
  };
};
/* export this contained component */
export default connect(
  mapStateToProps,
  {}
)(DebugingTool);



// WEBPACK FOOTER //
// ./src/components/DebugingTool/index.js